/**
 * Mengenstaffel auf der Produktseite.
 *
 * Zeigt die Staffelpreise (1/2/4/6/8 Gläser) als auswählbare Karten an und setzt beim Klick
 * die Menge im Warenkorb-Formular. Die Preise werden serverseitig in Liquid aus dem echten
 * Variantenpreis und den Rabattstufen berechnet — dieses Skript rechnet nichts nach, es
 * verbindet nur Karten und Mengenfeld.
 */
(function () {
  if (window.__casaVolumeTiersInit) return;
  window.__casaVolumeTiersInit = true;

  /**
   * Der Mengen-Stepper. Radios der Staffel heißen ebenfalls "quantity", wenn der Stepper
   * ausgeblendet ist — die sind hier ausdrücklich nicht gemeint, sonst überschreibt das
   * Skript den Wert der Auswahl selbst.
   */
  function quantityInput(root) {
    var selector = 'input[name="quantity"]:not([type="radio"])';
    var scope = root.closest('.product-form, product-form, .product-block-list, .product') || document;
    return scope.querySelector(selector) || document.querySelector(selector);
  }

  function setQuantity(root, qty) {
    var input = quantityInput(root);
    if (!input) return;

    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && qty > max) qty = max;

    input.value = qty;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function markActive(root, qty) {
    root.querySelectorAll('[data-volume-tier]').forEach(function (tier) {
      var tierQty = parseInt(tier.getAttribute('data-volume-tier'), 10);
      var isActive = tierQty === qty;
      tier.classList.toggle('is-selected', isActive);
      var radio = tier.querySelector('input[type="radio"]');
      if (radio) radio.checked = isActive;
    });
  }

  function init(root) {
    if (root.__casaTiersBound) return;
    root.__casaTiersBound = true;

    root.querySelectorAll('[data-volume-tier]').forEach(function (tier) {
      tier.addEventListener('click', function () {
        var qty = parseInt(tier.getAttribute('data-volume-tier'), 10);
        if (isNaN(qty)) return;
        setQuantity(root, qty);
        markActive(root, qty);
      });
    });

    var input = quantityInput(root);
    if (input) {
      input.addEventListener('change', function () {
        markActive(root, parseInt(input.value, 10));
      });
      markActive(root, parseInt(input.value, 10));
    }
  }

  function initAll() {
    document.querySelectorAll('[data-volume-tiers]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState === 'complete' || document.readyState === 'interactive') initAll();

  // Prestige tauscht die Buy-Box bei Variantenwechsel teilweise aus
  document.documentElement.addEventListener('variant:change', initAll);
})();
